import { render, staticRenderFns } from "./LocationsIcon.vue?vue&type=template&id=2b88586b"
import script from "./LocationsIcon.vue?vue&type=script&lang=js"
export * from "./LocationsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports